import type { Issue, IssueTypeIdentifier, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueTypeIdentifiersListItem } from "./IssueTypeIdentifiersListItem"

interface IssueTypeIdentifiersListProps {
	issue: Stored<Issue>
	issueTypeIdentifiers: Stored<IssueTypeIdentifier>[]
}

export const IssueTypeIdentifiersList = memo<IssueTypeIdentifiersListProps>((props) => {
	const { issue, issueTypeIdentifiers } = props

	return (
		<div className="flex flex-wrap gap-2">
			{issueTypeIdentifiers.map((issueTypeIdentifier) => {
				return (
					<IssueTypeIdentifiersListItem
						key={issueTypeIdentifier.uuid}
						issue={issue}
						issueTypeIdentifier={issueTypeIdentifier}
					/>
				)
			})}
		</div>
	)
})
IssueTypeIdentifiersList.displayName = "IssueTypeIdentifiersList"
